@file:OptIn(InternalResourceApi::class)

package evoshift.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/evoshift.composeapp.generated.resources/"

@delegate:ResourceContentHash(1_628_346_119)
public val Res.string.requests_absence_request: StringResource by lazy {
      StringResource("string:requests_absence_request", "requests_absence_request", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 240668, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 341844, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 220051, 52),
      ))
    }

@delegate:ResourceContentHash(13_015_120)
public val Res.string.requests_absences_column: StringResource by lazy {
      StringResource("string:requests_absences_column", "requests_absences_column", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 240733, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 341929, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 220104, 44),
      ))
    }

@delegate:ResourceContentHash(-1_682_118_736)
public val Res.string.requests_accepted: StringResource by lazy {
      StringResource("string:requests_accepted", "requests_accepted", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 240786, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 341994, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 220149, 49),
      ))
    }

@delegate:ResourceContentHash(-488_701_002)
public val Res.string.requests_approve_absence: StringResource by lazy {
      StringResource("string:requests_approve_absence", "requests_approve_absence", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 240977, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 342261, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 220328, 52),
      ))
    }

@delegate:ResourceContentHash(1_339_715_033)
public val Res.string.requests_approve_absence_confirm: StringResource by lazy {
      StringResource("string:requests_approve_absence_confirm", "requests_approve_absence_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 240840, 136),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 342060, 200),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 220199, 128),
      ))
    }

@delegate:ResourceContentHash(-365_970_134)
public val Res.string.requests_approve_description: StringResource by lazy {
      StringResource("string:requests_approve_description", "requests_approve_description", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 241042, 80),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 342346, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 220381, 84),
      ))
    }

@delegate:ResourceContentHash(-2_140_475_159)
public val Res.string.requests_approve_swap: StringResource by lazy {
      StringResource("string:requests_approve_swap", "requests_approve_swap", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 241197, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 342545, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 220536, 53),
      ))
    }

@delegate:ResourceContentHash(-1_218_713_699)
public val Res.string.requests_approve_swap_confirm: StringResource by lazy {
      StringResource("string:requests_approve_swap_confirm", "requests_approve_swap_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 241123, 73),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 342439, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 220466, 69),
      ))
    }

@delegate:ResourceContentHash(-786_149_014)
public val Res.string.requests_assigned_to: StringResource by lazy {
      StringResource("string:requests_assigned_to", "requests_assigned_to", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 241255, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 342611, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 220590, 52),
      ))
    }

@delegate:ResourceContentHash(1_237_762_891)
public val Res.string.requests_conflicts_unassigned: StringResource by lazy {
      StringResource("string:requests_conflicts_unassigned", "requests_conflicts_unassigned", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 241308, 89),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 342676, 137),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 220643, 93),
      ))
    }

@delegate:ResourceContentHash(1_642_545_824)
public val Res.string.requests_decided_approved: StringResource by lazy {
      StringResource("string:requests_decided_approved", "requests_decided_approved", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 241398, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 342814, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 220737, 45),
      ))
    }

@delegate:ResourceContentHash(-1_164_315_337)
public val Res.string.requests_decided_rejected: StringResource by lazy {
      StringResource("string:requests_decided_rejected", "requests_decided_rejected", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 241452, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 342872, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 220783, 45),
      ))
    }

@delegate:ResourceContentHash(-581_496_627)
public val Res.string.requests_event_clashes: StringResource by lazy {
      StringResource("string:requests_event_clashes", "requests_event_clashes", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 241502, 134),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 342934, 202),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 220829, 110),
      ))
    }

@delegate:ResourceContentHash(-465_354_757)
public val Res.string.requests_override_approve: StringResource by lazy {
      StringResource("string:requests_override_approve", "requests_override_approve", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 241637, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 343137, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 220940, 53),
      ))
    }

@delegate:ResourceContentHash(706_246_845)
public val Res.string.requests_override_note: StringResource by lazy {
      StringResource("string:requests_override_note", "requests_override_note", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 241695, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 343219, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 220994, 50),
      ))
    }

@delegate:ResourceContentHash(553_424_279)
public val Res.string.requests_override_shown: StringResource by lazy {
      StringResource("string:requests_override_shown", "requests_override_shown", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 241758, 71),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 343310, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 221045, 71),
      ))
    }

@delegate:ResourceContentHash(1_472_848_059)
public val Res.string.requests_override_text: StringResource by lazy {
      StringResource("string:requests_override_text", "requests_override_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 241830, 178),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 343410, 254),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 221117, 154),
      ))
    }

@delegate:ResourceContentHash(171_162_569)
public val Res.string.requests_override_title: StringResource by lazy {
      StringResource("string:requests_override_title", "requests_override_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 242009, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 343665, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 221272, 63),
      ))
    }

@delegate:ResourceContentHash(811_021_706)
public val Res.string.requests_pending: StringResource by lazy {
      StringResource("string:requests_pending", "requests_pending", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 242077, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 343757, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 221336, 48),
      ))
    }

@delegate:ResourceContentHash(1_419_206_466)
public val Res.string.requests_reject_absence: StringResource by lazy {
      StringResource("string:requests_reject_absence", "requests_reject_absence", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 242222, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 343954, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 221465, 51),
      ))
    }

@delegate:ResourceContentHash(568_361_077)
public val Res.string.requests_reject_absence_confirm: StringResource by lazy {
      StringResource("string:requests_reject_absence_confirm", "requests_reject_absence_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 242130, 91),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 343830, 123),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 221385, 79),
      ))
    }

@delegate:ResourceContentHash(1_533_645_508)
public val Res.string.requests_reject_description: StringResource by lazy {
      StringResource("string:requests_reject_description", "requests_reject_description", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 242282, 75),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 344042, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 221517, 79),
      ))
    }

@delegate:ResourceContentHash(1_987_258_934)
public val Res.string.requests_reject_reason_hint: StringResource by lazy {
      StringResource("string:requests_reject_reason_hint", "requests_reject_reason_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 242358, 87),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 344134, 135),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 221597, 95),
      ))
    }

@delegate:ResourceContentHash(-1_043_636_203)
public val Res.string.requests_reject_reason_label: StringResource by lazy {
      StringResource("string:requests_reject_reason_label", "requests_reject_reason_label", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 242446, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 344270, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 221693, 60),
      ))
    }

@delegate:ResourceContentHash(-1_535_906_015)
public val Res.string.requests_reject_swap: StringResource by lazy {
      StringResource("string:requests_reject_swap", "requests_reject_swap", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 242584, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 344476, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 221823, 52),
      ))
    }

@delegate:ResourceContentHash(193_552_322)
public val Res.string.requests_reject_swap_confirm: StringResource by lazy {
      StringResource("string:requests_reject_swap_confirm", "requests_reject_swap_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 242515, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 344367, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 221754, 68),
      ))
    }

@delegate:ResourceContentHash(-1_652_753_869)
public val Res.string.requests_resolve_failed: StringResource by lazy {
      StringResource("string:requests_resolve_failed", "requests_resolve_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 242637, 99),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 344545, 151),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 221876, 91),
      ))
    }

@delegate:ResourceContentHash(2_126_692_542)
public val Res.string.requests_swap_done: StringResource by lazy {
      StringResource("string:requests_swap_done", "requests_swap_done", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 242737, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 344697, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 221968, 50),
      ))
    }

@delegate:ResourceContentHash(-519_056_541)
public val Res.string.requests_swap_request: StringResource by lazy {
      StringResource("string:requests_swap_request", "requests_swap_request", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 242792, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 344768, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 222019, 53),
      ))
    }

@delegate:ResourceContentHash(2_070_184_027)
public val Res.string.requests_swaps_column: StringResource by lazy {
      StringResource("string:requests_swaps_column", "requests_swaps_column", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 242846, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 344834, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 222073, 45),
      ))
    }

@delegate:ResourceContentHash(441_619_399)
public val Res.string.requests_undo_changed: StringResource by lazy {
      StringResource("string:requests_undo_changed", "requests_undo_changed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 242888, 109),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 344880, 149),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 222119, 105),
      ))
    }

@delegate:ResourceContentHash(1_134_892_099)
public val Res.string.requests_undone: StringResource by lazy {
      StringResource("string:requests_undone", "requests_undone", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 242998, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 345030, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 222225, 83),
      ))
    }

@delegate:ResourceContentHash(-1_513_943_832)
public val Res.string.requests_work_request: StringResource by lazy {
      StringResource("string:requests_work_request", "requests_work_request", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 243066, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 345126, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 222309, 45),
      ))
    }

@delegate:ResourceContentHash(-1_365_715_965)
public val Res.string.revenue: StringResource by lazy {
      StringResource("string:revenue", "revenue", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 243128, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 345200, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 222355, 27),
      ))
    }

@delegate:ResourceContentHash(233_725_620)
public val Res.string.rich_bold: StringResource by lazy {
      StringResource("string:rich_bold", "rich_bold", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 243164, 33),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 345252, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 222383, 25),
      ))
    }

@delegate:ResourceContentHash(-1_460_276_406)
public val Res.string.rich_color: StringResource by lazy {
      StringResource("string:rich_color", "rich_color", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 243462, 34),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 345622, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 222637, 34),
      ))
    }

@delegate:ResourceContentHash(-1_741_167_972)
public val Res.string.rich_color_blue: StringResource by lazy {
      StringResource("string:rich_color_blue", "rich_color_blue", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 243198, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 345286, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 222409, 31),
      ))
    }

@delegate:ResourceContentHash(458_114_145)
public val Res.string.rich_color_green: StringResource by lazy {
      StringResource("string:rich_color_green", "rich_color_green", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 243234, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 345326, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 222441, 32),
      ))
    }

@delegate:ResourceContentHash(-140_090_724)
public val Res.string.rich_color_grey: StringResource by lazy {
      StringResource("string:rich_color_grey", "rich_color_grey", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 243271, 31),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 345371, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 222474, 31),
      ))
    }

@delegate:ResourceContentHash(1_149_227_559)
public val Res.string.rich_color_none: StringResource by lazy {
      StringResource("string:rich_color_none", "rich_color_none", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 243303, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 345411, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 222506, 35),
      ))
    }

@delegate:ResourceContentHash(114_813_703)
public val Res.string.rich_color_orange: StringResource by lazy {
      StringResource("string:rich_color_orange", "rich_color_orange", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 243343, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 345463, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 222542, 33),
      ))
    }

@delegate:ResourceContentHash(-2_065_660_046)
public val Res.string.rich_color_purple: StringResource by lazy {
      StringResource("string:rich_color_purple", "rich_color_purple", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 243389, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 345521, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 222576, 33),
      ))
    }

@delegate:ResourceContentHash(-53_718_878)
public val Res.string.rich_color_red: StringResource by lazy {
      StringResource("string:rich_color_red", "rich_color_red", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 243427, 34),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 345575, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 222610, 26),
      ))
    }

@delegate:ResourceContentHash(-1_757_342_194)
public val Res.string.rich_highlight: StringResource by lazy {
      StringResource("string:rich_highlight", "rich_highlight", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 243497, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 345673, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 222672, 34),
      ))
    }

@delegate:ResourceContentHash(-402_815_393)
public val Res.string.rich_indent: StringResource by lazy {
      StringResource("string:rich_indent", "rich_indent", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 243540, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 345744, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 222707, 39),
      ))
    }

@delegate:ResourceContentHash(719_481_609)
public val Res.string.rich_italic: StringResource by lazy {
      StringResource("string:rich_italic", "rich_italic", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 243584, 31),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 345808, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 222747, 27),
      ))
    }

@delegate:ResourceContentHash(-2_133_746_013)
public val Res.string.rich_link: StringResource by lazy {
      StringResource("string:rich_link", "rich_link", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 244101, 25),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 346585, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 223216, 25),
      ))
    }

@delegate:ResourceContentHash(-327_724_902)
public val Res.string.rich_link_address: StringResource by lazy {
      StringResource("string:rich_link_address", "rich_link_address", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 243616, 33),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 345844, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 222775, 37),
      ))
    }

@delegate:ResourceContentHash(750_434_664)
public val Res.string.rich_link_apply: StringResource by lazy {
      StringResource("string:rich_link_apply", "rich_link_apply", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 243650, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 345886, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 222813, 31),
      ))
    }

@delegate:ResourceContentHash(1_740_433_175)
public val Res.string.rich_link_hint: StringResource by lazy {
      StringResource("string:rich_link_hint", "rich_link_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 243686, 118),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 345942, 170),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 222845, 98),
      ))
    }

@delegate:ResourceContentHash(641_943_777)
public val Res.string.rich_link_invalid: StringResource by lazy {
      StringResource("string:rich_link_invalid", "rich_link_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 243805, 133),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 346113, 205),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 222944, 109),
      ))
    }

@delegate:ResourceContentHash(1_500_233_619)
public val Res.string.rich_link_remove: StringResource by lazy {
      StringResource("string:rich_link_remove", "rich_link_remove", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 243939, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 346319, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 223054, 40),
      ))
    }

@delegate:ResourceContentHash(-2_086_750_453)
public val Res.string.rich_link_select: StringResource by lazy {
      StringResource("string:rich_link_select", "rich_link_select", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 243980, 88),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 346392, 144),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 223095, 88),
      ))
    }

@delegate:ResourceContentHash(-2_133_746_013)
public val Res.string.rich_link_title: StringResource by lazy {
      StringResource("string:rich_link_title", "rich_link_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 244069, 31),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 346537, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 223184, 31),
      ))
    }

@delegate:ResourceContentHash(-464_068_653)
public val Res.string.rich_list_bullet: StringResource by lazy {
      StringResource("string:rich_list_bullet", "rich_list_bullet", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 244127, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 346627, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 223242, 44),
      ))
    }

@delegate:ResourceContentHash(1_080_601_236)
public val Res.string.rich_list_lettered: StringResource by lazy {
      StringResource("string:rich_list_lettered", "rich_list_lettered", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 244176, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 346696, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 223287, 46),
      ))
    }

@delegate:ResourceContentHash(-1_229_780_801)
public val Res.string.rich_list_numbered: StringResource by lazy {
      StringResource("string:rich_list_numbered", "rich_list_numbered", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 244227, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 346767, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 223334, 46),
      ))
    }

@delegate:ResourceContentHash(1_657_433_447)
public val Res.string.rich_outdent: StringResource by lazy {
      StringResource("string:rich_outdent", "rich_outdent", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 244278, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 346842, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 223381, 40),
      ))
    }

@delegate:ResourceContentHash(811_826_759)
public val Res.string.rich_size: StringResource by lazy {
      StringResource("string:rich_size", "rich_size", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 244466, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 347090, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 223557, 29),
      ))
    }

@delegate:ResourceContentHash(-1_636_688_570)
public val Res.string.rich_size_heading: StringResource by lazy {
      StringResource("string:rich_size_heading", "rich_size_heading", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 244323, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 346907, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 223422, 37),
      ))
    }

@delegate:ResourceContentHash(1_882_486_282)
public val Res.string.rich_size_large: StringResource by lazy {
      StringResource("string:rich_size_large", "rich_size_large", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 244365, 31),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 346957, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 223460, 31),
      ))
    }

@delegate:ResourceContentHash(1_014_741_975)
public val Res.string.rich_size_normal: StringResource by lazy {
      StringResource("string:rich_size_normal", "rich_size_normal", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 244397, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 347001, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 223492, 32),
      ))
    }

@delegate:ResourceContentHash(-971_514_566)
public val Res.string.rich_size_small: StringResource by lazy {
      StringResource("string:rich_size_small", "rich_size_small", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 244434, 31),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 347050, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 223525, 31),
      ))
    }

@delegate:ResourceContentHash(1_814_738_830)
public val Res.string.rich_strikethrough: StringResource by lazy {
      StringResource("string:rich_strikethrough", "rich_strikethrough", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 244504, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 347144, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 223587, 46),
      ))
    }

@delegate:ResourceContentHash(1_500_462_195)
public val Res.string.rich_toolbar: StringResource by lazy {
      StringResource("string:rich_toolbar", "rich_toolbar", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 244551, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 347203, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 223634, 36),
      ))
    }

@delegate:ResourceContentHash(686_542_491)
public val Res.string.rich_underline: StringResource by lazy {
      StringResource("string:rich_underline", "rich_underline", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 244588, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 347256, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 223671, 34),
      ))
    }

@delegate:ResourceContentHash(-1_133_959_978)
public val Res.string.role_new: StringResource by lazy {
      StringResource("string:role_new", "role_new", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 244797, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 347593, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 223860, 28),
      ))
    }

@delegate:ResourceContentHash(1_076_549_100)
public val Res.string.role_new_hint: StringResource by lazy {
      StringResource("string:role_new_hint", "role_new_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 244631, 165),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 347311, 281),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 223706, 153),
      ))
    }

@delegate:ResourceContentHash(-290_779_709)
public val Res.string.role_none: StringResource by lazy {
      StringResource("string:role_none", "role_none", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 244834, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 347638, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 223889, 29),
      ))
    }

@delegate:ResourceContentHash(1_941_383_265)
public val Res.string.role_other: StringResource by lazy {
      StringResource("string:role_other", "role_other", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 244872, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 347684, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 223919, 38),
      ))
    }

@delegate:ResourceContentHash(-968_526_497)
public val Res.string.roles_builtin: StringResource by lazy {
      StringResource("string:roles_builtin", "roles_builtin", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 244915, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 347735, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 223958, 41),
      ))
    }

@delegate:ResourceContentHash(-1_766_268_409)
public val Res.string.roles_copy: StringResource by lazy {
      StringResource("string:roles_copy", "roles_copy", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 244957, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 347793, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 224000, 42),
      ))
    }

@delegate:ResourceContentHash(390_775_008)
public val Res.string.roles_custom: StringResource by lazy {
      StringResource("string:roles_custom", "roles_custom", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 245008, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 347868, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 224043, 36),
      ))
    }

@delegate:ResourceContentHash(1_701_713_716)
public val Res.string.roles_delete_confirm: StringResource by lazy {
      StringResource("string:roles_delete_confirm", "roles_delete_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 245045, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 347913, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 224080, 64),
      ))
    }

@delegate:ResourceContentHash(1_910_309_803)
public val Res.string.roles_deleted: StringResource by lazy {
      StringResource("string:roles_deleted", "roles_deleted", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 245110, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 347990, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 224145, 37),
      ))
    }

@delegate:ResourceContentHash(-404_631_493)
public val Res.string.roles_edit_title: StringResource by lazy {
      StringResource("string:roles_edit_title", "roles_edit_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 245152, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 348048, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 224183, 36),
      ))
    }

@delegate:ResourceContentHash(-711_942_063)
public val Res.string.roles_intro: StringResource by lazy {
      StringResource("string:roles_intro", "roles_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 245193, 223),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 348117, 383),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 224220, 231),
      ))
    }

@delegate:ResourceContentHash(108_175_776)
public val Res.string.roles_name: StringResource by lazy {
      StringResource("string:roles_name", "roles_name", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 245466, 34),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 348570, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 224501, 30),
      ))
    }

@delegate:ResourceContentHash(977_903_453)
public val Res.string.roles_name_error: StringResource by lazy {
      StringResource("string:roles_name_error", "roles_name_error", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 245417, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 348501, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 224452, 48),
      ))
    }

@delegate:ResourceContentHash(710_391_149)
public val Res.string.roles_new_title: StringResource by lazy {
      StringResource("string:roles_new_title", "roles_new_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 245501, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 348617, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 224532, 35),
      ))
    }

@delegate:ResourceContentHash(-1_509_530_916)
public val Res.string.roles_none: StringResource by lazy {
      StringResource("string:roles_none", "roles_none", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 245537, 102),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 348665, 146),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 224568, 94),
      ))
    }

@delegate:ResourceContentHash(-1_105_935_623)
public val Res.string.roles_profile_intro: StringResource by lazy {
      StringResource("string:roles_profile_intro", "roles_profile_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 245640, 83),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 348812, 123),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 224663, 91),
      ))
    }

@delegate:ResourceContentHash(-359_101_499)
public val Res.string.roles_saved: StringResource by lazy {
      StringResource("string:roles_saved", "roles_saved", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 245724, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 348936, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 224755, 35),
      ))
    }

@delegate:ResourceContentHash(2_039_846_019)
public val Res.string.roles_summary: StringResource by lazy {
      StringResource("string:roles_summary", "roles_summary", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 245764, 81),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 348992, 121),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 224791, 73),
      ))
    }

@delegate:ResourceContentHash(1_438_275_407)
public val Res.string.roles_title: StringResource by lazy {
      StringResource("string:roles_title", "roles_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 245846, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 349114, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 224865, 43),
      ))
    }

@delegate:ResourceContentHash(-1_213_419_736)
public val Res.string.roster_accept_actual_time: StringResource by lazy {
      StringResource("string:roster_accept_actual_time", "roster_accept_actual_time", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 245890, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 349186, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 224909, 57),
      ))
    }

@delegate:ResourceContentHash(-2_025_590_051)
public val Res.string.roster_actual_range: StringResource by lazy {
      StringResource("string:roster_actual_range", "roster_actual_range", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 245960, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 349284, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 224967, 55),
      ))
    }

@delegate:ResourceContentHash(-449_057_750)
public val Res.string.roster_actual_time: StringResource by lazy {
      StringResource("string:roster_actual_time", "roster_actual_time", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 246092, 66),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 349440, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 225087, 58),
      ))
    }

@delegate:ResourceContentHash(-593_671_821)
public val Res.string.roster_actual_time_accepted: StringResource by lazy {
      StringResource("string:roster_actual_time_accepted", "roster_actual_time_accepted", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 246020, 71),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 349340, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 225023, 63),
      ))
    }

@delegate:ResourceContentHash(1_180_753_158)
public val Res.string.roster_add_additional: StringResource by lazy {
      StringResource("string:roster_add_additional", "roster_add_additional", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 246159, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 349539, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 225146, 57),
      ))
    }

@delegate:ResourceContentHash(-1_129_133_452)
public val Res.string.roster_add_custom_shift: StringResource by lazy {
      StringResource("string:roster_add_custom_shift", "roster_add_custom_shift", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 246221, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 349621, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 225204, 55),
      ))
    }

@delegate:ResourceContentHash(-1_318_584_714)
public val Res.string.roster_add_manual_slot: StringResource by lazy {
      StringResource("string:roster_add_manual_slot", "roster_add_manual_slot", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 246285, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 349701, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 225260, 50),
      ))
    }

@delegate:ResourceContentHash(370_229_456)
public val Res.string.roster_add_shift_template: StringResource by lazy {
      StringResource("string:roster_add_shift_template", "roster_add_shift_template", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 246336, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 349768, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 225311, 57),
      ))
    }

@delegate:ResourceContentHash(1_879_217_280)
public val Res.string.roster_all_filled: StringResource by lazy {
      StringResource("string:roster_all_filled", "roster_all_filled", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 246398, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 349850, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 225369, 41),
      ))
    }

@delegate:ResourceContentHash(2_039_982_289)
public val Res.string.roster_apply_day_template: StringResource by lazy {
      StringResource("string:roster_apply_day_template", "roster_apply_day_template", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 246448, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 349904, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 225411, 57),
      ))
    }

@delegate:ResourceContentHash(256_768_925)
public val Res.string.roster_assign_anyway: StringResource by lazy {
      StringResource("string:roster_assign_anyway", "roster_assign_anyway", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 246510, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 349994, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 225469, 48),
      ))
    }

@delegate:ResourceContentHash(75_774_577)
public val Res.string.roster_assign_role_time: StringResource by lazy {
      StringResource("string:roster_assign_role_time", "roster_assign_role_time", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 246563, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 350071, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 225518, 55),
      ))
    }

@delegate:ResourceContentHash(-1_007_073_370)
public val Res.string.roster_assign_shift: StringResource by lazy {
      StringResource("string:roster_assign_shift", "roster_assign_shift", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 246686, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 350230, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 225633, 43),
      ))
    }

@delegate:ResourceContentHash(1_837_438_644)
public val Res.string.roster_assign_shift_to: StringResource by lazy {
      StringResource("string:roster_assign_shift_to", "roster_assign_shift_to", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 246623, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 350147, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 225574, 58),
      ))
    }

@delegate:ResourceContentHash(-990_016_157)
public val Res.string.roster_assigned_shifts: StringResource by lazy {
      StringResource("string:roster_assigned_shifts", "roster_assigned_shifts", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 246738, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 350302, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 225677, 50),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString30Resources(map: MutableMap<String, StringResource>) {
  map.put("requests_absence_request", Res.string.requests_absence_request)
  map.put("requests_absences_column", Res.string.requests_absences_column)
  map.put("requests_accepted", Res.string.requests_accepted)
  map.put("requests_approve_absence", Res.string.requests_approve_absence)
  map.put("requests_approve_absence_confirm", Res.string.requests_approve_absence_confirm)
  map.put("requests_approve_description", Res.string.requests_approve_description)
  map.put("requests_approve_swap", Res.string.requests_approve_swap)
  map.put("requests_approve_swap_confirm", Res.string.requests_approve_swap_confirm)
  map.put("requests_assigned_to", Res.string.requests_assigned_to)
  map.put("requests_conflicts_unassigned", Res.string.requests_conflicts_unassigned)
  map.put("requests_decided_approved", Res.string.requests_decided_approved)
  map.put("requests_decided_rejected", Res.string.requests_decided_rejected)
  map.put("requests_event_clashes", Res.string.requests_event_clashes)
  map.put("requests_override_approve", Res.string.requests_override_approve)
  map.put("requests_override_note", Res.string.requests_override_note)
  map.put("requests_override_shown", Res.string.requests_override_shown)
  map.put("requests_override_text", Res.string.requests_override_text)
  map.put("requests_override_title", Res.string.requests_override_title)
  map.put("requests_pending", Res.string.requests_pending)
  map.put("requests_reject_absence", Res.string.requests_reject_absence)
  map.put("requests_reject_absence_confirm", Res.string.requests_reject_absence_confirm)
  map.put("requests_reject_description", Res.string.requests_reject_description)
  map.put("requests_reject_reason_hint", Res.string.requests_reject_reason_hint)
  map.put("requests_reject_reason_label", Res.string.requests_reject_reason_label)
  map.put("requests_reject_swap", Res.string.requests_reject_swap)
  map.put("requests_reject_swap_confirm", Res.string.requests_reject_swap_confirm)
  map.put("requests_resolve_failed", Res.string.requests_resolve_failed)
  map.put("requests_swap_done", Res.string.requests_swap_done)
  map.put("requests_swap_request", Res.string.requests_swap_request)
  map.put("requests_swaps_column", Res.string.requests_swaps_column)
  map.put("requests_undo_changed", Res.string.requests_undo_changed)
  map.put("requests_undone", Res.string.requests_undone)
  map.put("requests_work_request", Res.string.requests_work_request)
  map.put("revenue", Res.string.revenue)
  map.put("rich_bold", Res.string.rich_bold)
  map.put("rich_color", Res.string.rich_color)
  map.put("rich_color_blue", Res.string.rich_color_blue)
  map.put("rich_color_green", Res.string.rich_color_green)
  map.put("rich_color_grey", Res.string.rich_color_grey)
  map.put("rich_color_none", Res.string.rich_color_none)
  map.put("rich_color_orange", Res.string.rich_color_orange)
  map.put("rich_color_purple", Res.string.rich_color_purple)
  map.put("rich_color_red", Res.string.rich_color_red)
  map.put("rich_highlight", Res.string.rich_highlight)
  map.put("rich_indent", Res.string.rich_indent)
  map.put("rich_italic", Res.string.rich_italic)
  map.put("rich_link", Res.string.rich_link)
  map.put("rich_link_address", Res.string.rich_link_address)
  map.put("rich_link_apply", Res.string.rich_link_apply)
  map.put("rich_link_hint", Res.string.rich_link_hint)
  map.put("rich_link_invalid", Res.string.rich_link_invalid)
  map.put("rich_link_remove", Res.string.rich_link_remove)
  map.put("rich_link_select", Res.string.rich_link_select)
  map.put("rich_link_title", Res.string.rich_link_title)
  map.put("rich_list_bullet", Res.string.rich_list_bullet)
  map.put("rich_list_lettered", Res.string.rich_list_lettered)
  map.put("rich_list_numbered", Res.string.rich_list_numbered)
  map.put("rich_outdent", Res.string.rich_outdent)
  map.put("rich_size", Res.string.rich_size)
  map.put("rich_size_heading", Res.string.rich_size_heading)
  map.put("rich_size_large", Res.string.rich_size_large)
  map.put("rich_size_normal", Res.string.rich_size_normal)
  map.put("rich_size_small", Res.string.rich_size_small)
  map.put("rich_strikethrough", Res.string.rich_strikethrough)
  map.put("rich_toolbar", Res.string.rich_toolbar)
  map.put("rich_underline", Res.string.rich_underline)
  map.put("role_new", Res.string.role_new)
  map.put("role_new_hint", Res.string.role_new_hint)
  map.put("role_none", Res.string.role_none)
  map.put("role_other", Res.string.role_other)
  map.put("roles_builtin", Res.string.roles_builtin)
  map.put("roles_copy", Res.string.roles_copy)
  map.put("roles_custom", Res.string.roles_custom)
  map.put("roles_delete_confirm", Res.string.roles_delete_confirm)
  map.put("roles_deleted", Res.string.roles_deleted)
  map.put("roles_edit_title", Res.string.roles_edit_title)
  map.put("roles_intro", Res.string.roles_intro)
  map.put("roles_name", Res.string.roles_name)
  map.put("roles_name_error", Res.string.roles_name_error)
  map.put("roles_new_title", Res.string.roles_new_title)
  map.put("roles_none", Res.string.roles_none)
  map.put("roles_profile_intro", Res.string.roles_profile_intro)
  map.put("roles_saved", Res.string.roles_saved)
  map.put("roles_summary", Res.string.roles_summary)
  map.put("roles_title", Res.string.roles_title)
  map.put("roster_accept_actual_time", Res.string.roster_accept_actual_time)
  map.put("roster_actual_range", Res.string.roster_actual_range)
  map.put("roster_actual_time", Res.string.roster_actual_time)
  map.put("roster_actual_time_accepted", Res.string.roster_actual_time_accepted)
  map.put("roster_add_additional", Res.string.roster_add_additional)
  map.put("roster_add_custom_shift", Res.string.roster_add_custom_shift)
  map.put("roster_add_manual_slot", Res.string.roster_add_manual_slot)
  map.put("roster_add_shift_template", Res.string.roster_add_shift_template)
  map.put("roster_all_filled", Res.string.roster_all_filled)
  map.put("roster_apply_day_template", Res.string.roster_apply_day_template)
  map.put("roster_assign_anyway", Res.string.roster_assign_anyway)
  map.put("roster_assign_role_time", Res.string.roster_assign_role_time)
  map.put("roster_assign_shift", Res.string.roster_assign_shift)
  map.put("roster_assign_shift_to", Res.string.roster_assign_shift_to)
  map.put("roster_assigned_shifts", Res.string.roster_assigned_shifts)
}
